import * as React from 'react';
import ToggleButtons from 'src/components/common/ToggleButtons';
import { IButtons } from 'src/components/common/ToggleButtons/ToggleButtons';
import './FiltersBarDesktop.scss';
import DateRange from 'src/components/common/DateRange';
import Dropdown from 'src/components/common/Dropdown';
import { IOption } from 'src/components/common/Dropdown/Dropdown';
import Input from 'src/components/common/Input';
import Button from 'src/components/common/Button';
import BadgeButton from 'src/components/common/BadgeButton';

export interface IFilterBarProps {
  typeOfItemOptions: IButtons[];
  selectedTypeOfItem: string;
  onSelectedTypeOfItemChange: (value: string) => void;
  filterByOptions?: IOption[];
  selectedFilterBy?: string;
  onSelectedFilterByChange?: (value: string) => void;
  searchByOptions: IOption[];
  selectedSearchBy: string;
  onSelectedSearchByChange: (value: string) => void;
  dates?: any;
  onDatesChange?: (date: any) => void;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onSearchButtonClick: () => void;
  itemsLength?: number;
  returnCartAction?: () => void;
  t?: any;
  forItemValue?: any;
  forItemStatusValue?: any;
}

const FiltersBarDesktop: React.FC<IFilterBarProps> = ({
  typeOfItemOptions,
  selectedTypeOfItem,
  onSelectedTypeOfItemChange,
  filterByOptions,
  selectedFilterBy,
  onSelectedFilterByChange,
  searchByOptions,
  selectedSearchBy,
  onSelectedSearchByChange,
  dates,
  onDatesChange,
  searchQuery,
  onSearchQueryChange,
  onSearchButtonClick,
  itemsLength,
  returnCartAction,
  t
}) => {
  return (
    <div className="rp-filter-bar-desktop">
      <div className="rp-filter-bar-desktop-type-of-item">
        <label className="rp-filter-bar-desktop-label">
          {t('myReturns.typeOfItem')}:
        </label>
        <ToggleButtons
          value={selectedTypeOfItem}
          onValueChange={value => onSelectedTypeOfItemChange(value)}
          buttons={typeOfItemOptions}
        />
      </div>

      <div className="rp-filter-bar-desktop-date">
        <label className="rp-filter-bar-desktop-label">
          {t('categories.filterBy')}:
        </label>
        {filterByOptions ? (
          <Dropdown
            options={filterByOptions}
            onSelected={value => onSelectedFilterByChange(value)}
            activeOption={selectedFilterBy}
          />
        ) : (
          <DateRange
            onDatesSelected={selectedDates => onDatesChange(selectedDates)}
            onClear={() => onDatesChange(null)}
            dates={dates}
          />
        )}
      </div>

      <div className="rp-filter-bar-desktop-search-by">
        <label className="rp-filter-bar-desktop-label">
          {t('common.searchBy')}:
        </label>
        <div className="rp-filter-bar-desktop-query-container">
          <Dropdown
            options={searchByOptions}
            onSelected={onSelectedSearchByChange}
            activeOption={selectedSearchBy}
          />
          {selectedSearchBy === 'invoiceNumber' ? (
            <input
              type="number"
              className="rp-filter-bar-desktop-search-input rp-filter-bar-desktop-search-input-additional"
              value={searchQuery}
              onChange={e => {
                e.target.value = e.target.value.slice(0, 7);
                onSearchQueryChange(e.target.value);
              }}
              placeholder={t('myReturns.searchHerePlaceHolder')}
              maxLength={7}
            />
          ) : (
            <Input
              className="rp-filter-bar-desktop-search-input"
              value={searchQuery}
              onChange={onSearchQueryChange}
              placeholder={t('myReturns.searchHerePlaceHolder')}
            />
          )}
          <Button
            label={(t('common.search') as string).toUpperCase()}
            action={onSearchButtonClick}
            buttonClass="primary-button"
            height="40px"
          />
        </div>
      </div>

      {!filterByOptions && (
        <BadgeButton
          disabled={itemsLength === 0}
          action={returnCartAction}
          badgeValue={itemsLength}
          label={(t('myReturns.returnsCart') as string).toUpperCase()}
          buttonClass="rp-filter-bar-desktop-action-button"
        />
      )}
    </div>
  );
};

export default FiltersBarDesktop;
